import { createStore, createEffect, createEvent, combine } from 'effector';
import { ApiUtilsV2 } from '@shared/utils';
import { AccountsApi, RequestStrategyEnum, type AccountRequest, type AccountResponse, type WithSignal } from '@shared/api';

const getAccountsEffect = createEffect(({ signal, ...request }: WithSignal<AccountRequest> = {}) => AccountsApi.getAccounts(request, signal));
const clearEvent = createEvent();

const $dataStore = createStore<AccountResponse[]>([])
  .on(getAccountsEffect.done, (_, data) => data.result.data ?? [])
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(getAccountsEffect.pending, (_, pending) => pending)
  .on(getAccountsEffect.fail, (_, data) => ApiUtilsV2.abortApiLoadingFailCaseTrigger(data.error))
  .on(getAccountsEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getAccountsEffect, () => null)
  .on(getAccountsEffect.fail, () => 'Something went wrong while fetching Accounts. Please try again.')
  .on(getAccountsEffect.done, () => null)
  .reset(clearEvent);

const getAccountsApi = ApiUtilsV2.wrapperApi(getAccountsEffect, RequestStrategyEnum.Abort);
clearEvent.watch(() => getAccountsApi.cancel());

export const $accountListStore = {
  events: {
    getAccounts: getAccountsApi.trigger,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
